import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WizardFormData } from './schemas';

import { WizardAutocompleteField, WizardToggleField } from './components';
import AutoCreateTrafficSourceForm from './components/AutoCreateTrafficSourceForm';
import { useWizardData } from './hooks/useWizardData';

function TrafficSourceStep() {
  const { watch } = useFormContext<WizardFormData>();
  const { trafficSources } = useWizardData();

  const autoCreateTrafficSource = watch('autoCreateTrafficSource');

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Traffic Source Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure how traffic will be tracked for this offer.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <WizardToggleField
          label="Automatically create traffic source"
          name="autoCreateTrafficSource"
          helperText="Automatically create a traffic source for this offer"
        />

        {autoCreateTrafficSource ? (
          <AutoCreateTrafficSourceForm />
        ) : (
          <Box sx={{ ml: 4 }}>
            <WizardAutocompleteField
              label="Traffic Source"
              name="selectedTrafficSourceId"
              options={trafficSources.map((source) => ({
                id: source._id,
                label: source.name,
              }))}
              helperText="Select a traffic source to use for this offer"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default TrafficSourceStep;
